module.exports = __webpack_public_path__ + "662350b2e52ca1d0a3cd51f0965a0519.fbx";